<template>
    <div>
        <div class="container mb-4">
            <h1>Film Permits</h1>
        </div>
        <ForgotPasswordForm @email-sent="status = 'sent'; response = $event" v-if="status == ''"/>
        <div class="container" v-if="status == 'sent' && response !== 'email_not_existed'">
            <div class="col-md-8">
                <div class="alert alert-success">
                    <p>
                        If this is a valid email address, you will receive a verification or password reset email.
                        If you do not receive the email, you can <router-link to="/create-account">create a new account</router-link> 
                        or email <a href="mailto:film.office@mississauga.ca">film.office@mississauga.ca</a> for support.
                    </p>
                </div>
            </div>
        </div>
        <div class="container" v-if="status == 'sent' && response == 'email_not_existed'">
            <div class="col-md-8">
                <div class="alert alert-success"> <!--alert-danger-->
                    <p>
                        If this is a valid email address, you will receive a verification or password reset email.
                        If you do not receive the email, you can <router-link to="/create-account">create a new account</router-link> 
                        or email <a href="mailto:film.office@mississauga.ca">film.office@mississauga.ca</a> for support.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ForgotPasswordForm from "@/components/ForgotPasswordForm";

export default {
    name: "forgot-password",
    components: {
        ForgotPasswordForm
    },
    data() {
        return {
            status: "",
            response: ""
        };
    }
};
</script>